import { PiBookmarkBold, PiUserBold } from "react-icons/pi";

import { IconType } from "react-icons";
import { HiOutlineHome } from "react-icons/hi2";

interface IEnv {
  API_ENDPOINT: string;
  NAVBAR_LINKS: {
    caption: string;
    destination: string;
    description: string;
    accentColor: string;
    icon?: IconType;
  }[];
  STRIPE_KEY: string;
  ENCRYPTION_KEY: string;
  CAPTIONS: {
    [key: string]: {
      [key: string]: string;
    };
  };
  LUGGAGE_LOCKERS_DIMENSIONS: {
    [key: string]: {
      width: number;
      height: number;
      depth: number;
    };
  };
}

export const ENV: IEnv = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || "https://api.salacity.es",
  NAVBAR_LINKS: [
    {
      caption: "Inicio",
      destination: "/",
      description: "Vista inicial de tu cuenta",
      accentColor: "brand.200",
      icon: HiOutlineHome,
    },
    {
      caption: "Reservas",
      destination: "/bookings",
      description: "Ver reservas realizadas",
      accentColor: "blue.200",
      icon: PiBookmarkBold,
    },
    {
      caption: "Perfil",
      destination: "/profile",
      description: "Mantén tus datos actualizados",
      accentColor: "green.200",
      icon: PiUserBold,
    },
  ],
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY || "",
  ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY || "",
  CAPTIONS: {
    usage: {
      luggage: "Maletas",
      belongings: "Pertenencias",
      scooter: "Patinetes",
    },
  },
  LUGGAGE_LOCKERS_DIMENSIONS: {
    M: {
      width: 30,
      height: 46,
      depth: 58,
    },
    L: {
      width: 50,
      height: 46,
      depth: 58,
    },
    XL: {
      width: 80,
      height: 46,
      depth: 58,
    },
  },
};
